
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "apache-atlas-hook-for-apache-sqoop"
    }}>{`Apache Atlas Hook for Apache Sqoop`}</h1>
    <h2 {...{
      "id": "sqoop-model"
    }}>{`Sqoop Model`}</h2>
    <p>{`Sqoop model includes the following types:`}</p>
    <ul>
      <li parentName="ul">{`Entity types:`}
        <ul parentName="li">
          <li parentName="ul">{`sqoop_process`}
            <ul parentName="li">
              <li parentName="ul">{`super-types: Process`}</li>
              <li parentName="ul">{`attributes: qualifiedName, name, description, owner, inputs, outputs, operation, commandlineOpts, startTime, endTime, userName`}</li>
            </ul>
          </li>
          <li parentName="ul">{`sqoop_dbdatastore`}
            <ul parentName="li">
              <li parentName="ul">{`super-types: DataSet`}</li>
              <li parentName="ul">{`attributes: qualifiedName, name, description, owner, dbStoreType, storeUse, storeUri, source`}</li>
            </ul>
          </li>
        </ul>
      </li>
      <li parentName="ul">{`Enum types:`}
        <ul parentName="li">
          <li parentName="ul">{`sqoop_operation_type`}
            <ul parentName="li">
              <li parentName="ul">{`values: IMPORT, EXPORT, EVAL`}</li>
            </ul>
          </li>
          <li parentName="ul">{`sqoop_dbstore_usage`}
            <ul parentName="li">
              <li parentName="ul">{`values: TABLE, QUERY, PROCEDURE, OTHER`}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <p>{`Sqoop entities are created and de-duped in Atlas using unique attribute qualifiedName, whose value should be formatted as detailed below.`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`sqoop_process.qualifiedName:     sqoop <operation> --connect <url> {[--table <tableName>] || [--database <databaseName>]} [--query <storeQuery>]
sqoop_dbdatastore.qualifiedName: <storeType> --url <storeUri> {[--table <tableName>] || [--database <databaseName>]} [--query <storeQuery>]  --hive-<operation> --hive-database <databaseName> [--hive-table <tableName>] --hive-cluster <clusterName>`}
    </SyntaxHighlighter>
    <h2 {...{
      "id": "sqoop-hook"
    }}>{`Sqoop Hook`}</h2>
    <p>{`Sqoop added a SqoopJobDataPublisher that publishes data to Atlas after completion of import Job. Today, only hiveImport is supported in SqoopHook.
This is used to add entities in Atlas using the model detailed above.`}</p>
    <p>{`Follow the instructions below to setup Atlas hook in Hive:`}</p>
    <p>{`Add the following properties to enable Atlas hook in Sqoop:`}</p>
    <ul>
      <li parentName="ul">{`Set-up Atlas hook in `}<inlineCode parentName="li">{`<sqoop-conf>`}</inlineCode>{`/sqoop-site.xml by adding the following:`}</li>
    </ul>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`<property>
     <name>sqoop.job.data.publish.class</name>
     <value>org.apache.atlas.sqoop.hook.SqoopHook</value>
   </property>`}
    </SyntaxHighlighter>
    <ul>
      <li parentName="ul">{`untar apache-atlas-\${project.version}-sqoop-hook.tar.gz`}</li>
      <li parentName="ul">{`cd apache-atlas-sqoop-hook-\${project.version}`}</li>
      <li parentName="ul">{`Copy entire contents of folder apache-atlas-sqoop-hook-\${project.version}/hook/sqoop to `}<inlineCode parentName="li">{`<atlas package>`}</inlineCode>{`/hook/sqoop`}</li>
      <li parentName="ul">{`Copy `}<inlineCode parentName="li">{`<atlas-conf>`}</inlineCode>{`/atlas-application.properties to the sqoop conf directory `}<inlineCode parentName="li">{`<sqoop-conf>`}</inlineCode>{`/`}</li>
      <li parentName="ul">{`Link `}<inlineCode parentName="li">{`<atlas package>`}</inlineCode>{`/hook/sqoop/*.jar in sqoop lib`}</li>
    </ul>
    <p>{`The following properties in atlas-application.properties control the thread pool and notification details:`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`atlas.hook.sqoop.synchronous=false # whether to run the hook synchronously. false is recommended to avoid delays in Sqoop operation completion. Default: false
atlas.hook.sqoop.numRetries=3      # number of retries for notification failure. Default: 3
atlas.hook.sqoop.queueSize=10000   # queue size for the threadpool. Default: 10000
atlas.cluster.name=primary # clusterName to use in qualifiedName of entities. Default: primary
atlas.kafka.zookeeper.connect=                    # Zookeeper connect URL for Kafka. Example: localhost:2181
atlas.kafka.zookeeper.connection.timeout.ms=30000 # Zookeeper connection timeout. Default: 30000
atlas.kafka.zookeeper.session.timeout.ms=60000    # Zookeeper session timeout. Default: 60000
atlas.kafka.zookeeper.sync.time.ms=20             # Zookeeper sync time. Default: 20`}
    </SyntaxHighlighter>
    <p>{`Other configurations for Kafka notification producer can be specified by prefixing the configuration name with "atlas.kafka.". For list of configuration supported by Kafka producer, please refer to `}<a parentName="p" {...{
        "href": "http://kafka.apache.org/documentation/#producerconfigs"
      }}>{`Kafka Producer Configs`}</a></p>
    <h2 {...{
      "id": "notes"
    }}>{`NOTES`}</h2>
    <ul>
      <li parentName="ul">{`Only the following sqoop operations are captured by sqoop hook currently`}
        <ul parentName="li">
          <li parentName="ul">{`hiveImport`}</li>
        </ul>
      </li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;